<template>
  <div class="main-box store-apply-info">
    <div class="page-head">
      <div>
        <h2>门店申请详情</h2>
      </div>
      <div class="head-actions">
        <el-button size="small" @click="$router.go(-1)">返回</el-button>
        <el-button type="primary" size="small" @click="showBox()" v-if="info.status == 0">审核</el-button>
      </div>
    </div>

    <div class="content-layout">
      <div class="left-panel">
        <section class="info-section">
          <div class="section-title">申请信息</div>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="门店名称">{{ info.store_name || '-' }}</el-descriptions-item>
            <el-descriptions-item label="审核状态">
              <el-tag size="mini" v-if="info.status == 1" type="success">审核通过</el-tag>
              <el-tag size="mini" v-else-if="info.status == 2" type="danger">审核未通过</el-tag>
              <el-tag size="mini" v-else>待审核</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="联系人">{{ info.name || '-' }}</el-descriptions-item>
            <el-descriptions-item label="手机号">{{ info.mobile || '-' }}</el-descriptions-item>
            <el-descriptions-item label="提交时间">{{ info.create_time || '-' }}</el-descriptions-item>
            <el-descriptions-item label="审核时间">{{ info.apply_time || '-' }}</el-descriptions-item>
            <el-descriptions-item label="地址">{{ fullAddress || '-' }}</el-descriptions-item>
            <el-descriptions-item label="坐标">{{ currentCoordText }}</el-descriptions-item>
            <el-descriptions-item label="审核备注" :span="2">{{ info.apply_remark || info.remark || '-' }}</el-descriptions-item>
          </el-descriptions>
        </section>

        <section class="info-section">
          <div class="section-title">申请人信息</div>
          <div class="member-card">
            <el-avatar :size="54" :src="info.member && info.member.avatar"></el-avatar>
            <div class="member-meta">
              <div class="member-name">{{ info.member && info.member.name || '-' }}</div>
              <div>ID：{{ info.member && info.member.user_id || '-' }}</div>
              <div>手机号：{{ info.member && info.member.mobile || '-' }}</div>
            </div>
          </div>
        </section>

        <section class="info-section">
          <div class="section-title">邀请人信息</div>
          <div class="member-card" v-if="info.share_member && info.share_member.user_id">
            <el-avatar :size="54" :src="info.share_member.avatar"></el-avatar>
            <div class="member-meta">
              <div class="member-name">{{ info.share_member.name || '-' }}</div>
              <div>ID：{{ info.share_member.user_id || '-' }}</div>
              <div>手机号：{{ info.share_member.mobile || '-' }}</div>
            </div>
          </div>
          <el-empty v-else description="暂无分享人" :image-size="80"></el-empty>
        </section>
      </div>

      <div class="middle-panel">
        <div class="store-list-box" v-if="validStoreList.length">
          <div class="store-list-head">门店列表</div>
          <div class="store-list">
            <div
                class="store-item"
                :class="{active: activeStoreKey === getStoreKey(item, index)}"
                v-for="(item,index) in validStoreList"
                :key="getStoreKey(item, index)"
                role="button"
                tabindex="0"
                @click="focusStore(item, index)"
                @keyup.enter="focusStore(item, index)">
              <i class="el-icon-location"></i>
              <div class="store-text">
                <span>
                  {{ getStoreName(item) }}
                </span>
                <em v-if="item.is_current">当前门店</em>
                <em v-else>{{ formatStoreMeta(item) }}</em>
              </div>
            </div>
          </div>
        </div>
        <el-empty v-else description="暂无门店坐标" :image-size="80"></el-empty>
      </div>

      <div class="right-panel">
        <div class="map-head">
          <div>
            <div class="section-title">腾讯地图</div>
            <div class="sub-title" v-if="editLocationMode">点击地图可修改当前审核门店坐标</div>
            <div class="sub-title" v-else>已标记门店：{{ validStoreList.length }}</div>
          </div>
          <div class="map-actions">
            <template v-if="editLocationMode">
              <el-button size="mini" @click="cancelEditLocation()">取消</el-button>
              <el-button type="primary" size="mini" @click="saveLocation()">保存坐标</el-button>
            </template>
            <el-button type="primary" plain size="mini" @click="startEditLocation()" v-else>修改坐标</el-button>
          </div>
        </div>
        <div class="location-edit-bar" v-if="editLocationMode">
          当前选择：{{ pendingCoordText }}
        </div>
        <div class="map-wrap">
          <div ref="storeMap" class="store-map"></div>
          <div class="map-empty" v-if="mapMessage">{{ mapMessage }}</div>
        </div>
      </div>
    </div>

    <el-dialog
        title="审核门店"
        :visible.sync="showDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="500px">
      <el-form :model="applyInfo" label-position="right" ref="ruleForm" label-width="60px" class="ruleForm" size="small">
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="applyInfo.status">
            <el-radio :label="item.id" v-for="(item,index) in statusList" :key="index" :value="item.id">{{item.title}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="applyInfo.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveApply()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
let tencentMapLoading = null

export default {
  components: {},
  data() {
    return {
      source_domain: this.config.SOURCE_DOMAIN,
      showDialog: false,
      info: {
        id: '',
      },
      applyInfo: {
        id: '',
        status: '',
        remark: ''
      },
      statusList: [
        {id: 1, title: '通过'},
        {id: 2, title: '拒绝'},
      ],
      storeList: [],
      map: null,
      markerLayer: null,
      labelLayer: null,
      activeStoreKey: '',
      editLocationMode: false,
      pendingLocation: null,
      mapClickHandler: null,
      mapMessage: ''
    };
  },
  computed: {
    fullAddress() {
      return [
        this.info.province_name,
        this.info.city_name,
        this.info.district_name,
        this.info.address
      ].filter(Boolean).join('')
    },
    validStoreList() {
      return this.storeList
        .map(item => {
          const lat = this.pickNumber(item, ['lat', 'latitude'])
          const lng = this.pickNumber(item, ['lng', 'longitude'])
          return Object.assign({}, item, {lat, lng})
        })
        .filter(item => item.lat && item.lng)
    },
    currentStoreKey() {
      return this.info.id ? 'current_' + this.info.id : ''
    },
    currentCoordText() {
      const lat = this.pickNumber(this.info, ['lat', 'latitude'])
      const lng = this.pickNumber(this.info, ['lng', 'longitude'])
      if (!lat || !lng) return '-'
      return this.formatLocation(lat, lng)
    },
    pendingCoordText() {
      if (!this.pendingLocation) return this.currentCoordText
      return this.formatLocation(this.pendingLocation.lat, this.pendingLocation.lng)
    }
  },
  created() {
    if (this.$route.query.id) {
      this.info.id = this.$route.query.id
      this.getInfo()
    }
  },
  mounted() {
    this.renderMap()
  },
  beforeDestroy() {
    if (this.map && this.mapClickHandler) this.map.off('click', this.mapClickHandler)
    if (this.markerLayer) this.markerLayer.setMap(null)
    if (this.labelLayer) this.labelLayer.setMap(null)
    this.mapClickHandler = null
    this.markerLayer = null
    this.labelLayer = null
    this.map = null
  },
  methods: {
    showBox() {
      this.applyInfo.id = this.info.id
      this.applyInfo.status = ''
      this.applyInfo.remark = ''
      this.showDialog = true
    },
    saveApply() {
      if(this.applyInfo.status === '') {
        this.fail('请选择审核状态')
        return false
      }
      if(this.applyInfo.status == 2 && this.applyInfo.remark === '') {
        this.fail('请填写拒绝理由')
        return false
      }
      this.$api.merchant.storeShenhe(this.applyInfo, res => {
        if(res.errcode == 0) {
          this.success('保存成功')
          this.showDialog = false
          this.getInfo()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    getInfo() {
      const that = this
      that.showLoading()
      this.$api.merchant.storeInfo({id: this.info.id}, function (res) {
        that.hideLoading()
        if (res.errcode == 0) {
          that.info = res.data || {}
          that.pendingLocation = null
          that.editLocationMode = false
          that.storeList = that.resolveStoreList(res.data)
          that.$nextTick(function () {
            that.renderMap()
          })
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    resolveStoreList(data) {
      if (!data) return []
      let list = []
      if (Array.isArray(data.storeList)) list = data.storeList
      if (Array.isArray(data.store_list)) list = data.store_list
      if (Array.isArray(data.stores)) list = data.stores
      list = list.filter(item => String(item.id) !== String(data.id))
      if (this.pickNumber(data, ['lat', 'latitude']) && this.pickNumber(data, ['lng', 'longitude'])) {
        list.unshift({
          id: data.id,
          store_name: data.store_name,
          lat: data.lat,
          lng: data.lng,
          is_current: true
        })
      }
      return list
    },
    pickNumber(item, keys) {
      for (let i = 0; i < keys.length; i++) {
        const value = Number(item[keys[i]])
        if (!Number.isNaN(value) && value !== 0) {
          return value
        }
      }
      return ''
    },
    getStoreName(item) {
      return item.title || item.store_name || item.name || '未命名门店'
    },
    getStoreKey(item, index) {
      if (item.is_current && this.currentStoreKey) return this.currentStoreKey
      if (item.id) return String(item.id)
      return [
        this.getStoreName(item),
        item.lat,
        item.lng,
        index
      ].join('_')
    },
    formatCoord(item) {
      return this.formatLocation(item.lat, item.lng)
    },
    formatStoreMeta(item) {
      if (item.distance !== undefined && item.distance !== null && item.distance !== '') {
        const distance = Number(item.distance)
        if (!Number.isNaN(distance)) {
          return (distance / 1000).toFixed(2) + 'km'
        }
      }
      return this.formatCoord(item)
    },
    formatLocation(lat, lng) {
      return Number(lng).toFixed(6) + '，' + Number(lat).toFixed(6)
    },
    renderMap() {
      if (!this.$refs.storeMap) return
      if (!this.validStoreList.length && !this.editLocationMode) {
        this.mapMessage = '暂无可用门店坐标'
        return
      }
      this.loadTencentMap().then(() => {
        this.mapMessage = ''
        this.drawMarkers()
      }).catch(() => {
        this.mapMessage = '腾讯地图加载失败，请检查地图 Key 配置'
      })
    },
    startEditLocation() {
      this.editLocationMode = true
      const lat = this.pickNumber(this.info, ['lat', 'latitude'])
      const lng = this.pickNumber(this.info, ['lng', 'longitude'])
      this.pendingLocation = lat && lng ? {lat, lng} : null
      if (this.currentStoreKey) {
        this.activeStoreKey = this.currentStoreKey
      }
      this.renderMap()
      const currentStore = this.validStoreList.find((item, index) => this.getStoreKey(item, index) === this.currentStoreKey)
      if (currentStore) {
        this.focusStore(currentStore, 0)
      }
    },
    cancelEditLocation() {
      this.editLocationMode = false
      this.pendingLocation = null
      this.storeList = this.resolveStoreList(this.info)
      this.$nextTick(() => this.drawMarkers(false))
    },
    saveLocation() {
      if (!this.pendingLocation) {
        this.fail('请先在地图上选择坐标')
        return false
      }
      this.$api.merchant.storeUpdateLocation({
        id: this.info.id,
        lat: this.pendingLocation.lat,
        lng: this.pendingLocation.lng
      }, res => {
        if (res.errcode == 0) {
          this.success('坐标保存成功')
          this.getInfo()
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    focusStore(item, index) {
      this.activeStoreKey = this.getStoreKey(item, index)

      if (!window.TMap || !this.map) {
        this.renderMap()
        return
      }

      const position = new window.TMap.LatLng(item.lat, item.lng)
      this.map.setCenter(position)
      if (this.map.setZoom) {
        this.map.setZoom(16)
      }
      this.drawMarkers(false)
    },
    updateCurrentLocation(latLng) {
      if (!this.editLocationMode || !latLng) return
      const lat = Number(latLng.getLat ? latLng.getLat() : latLng.lat)
      const lng = Number(latLng.getLng ? latLng.getLng() : latLng.lng)
      if (Number.isNaN(lat) || Number.isNaN(lng)) return
      this.pendingLocation = {
        lat: Number(lat.toFixed(6)),
        lng: Number(lng.toFixed(6))
      }
      this.syncCurrentStoreLocation(this.pendingLocation.lat, this.pendingLocation.lng)
      this.activeStoreKey = this.currentStoreKey
      this.drawMarkers(false)
      this.map.setCenter(new window.TMap.LatLng(this.pendingLocation.lat, this.pendingLocation.lng))
    },
    syncCurrentStoreLocation(lat, lng) {
      const currentIndex = this.storeList.findIndex(item => item.is_current)
      const currentStore = {
        id: this.info.id,
        store_name: this.info.store_name,
        lat,
        lng,
        is_current: true
      }
      if (currentIndex > -1) {
        this.$set(this.storeList, currentIndex, currentStore)
      } else {
        this.storeList.unshift(currentStore)
      }
    },
    loadTencentMap() {
      if (window.TMap) return Promise.resolve()
      if (tencentMapLoading) return tencentMapLoading

      tencentMapLoading = new Promise((resolve, reject) => {
        this.$api.merchant.sysSet(res => {
          if (res.errcode != 0) {
            tencentMapLoading = null
            reject(new Error(res.errmsg || 'map key load failed'))
            return
          }
          const key = res.data.qq_map_key
          if (!key) {
            tencentMapLoading = null
            reject(new Error('missing map key'))
            return
          }

          const script = document.createElement('script')
          script.src = 'https://map.qq.com/api/gljs?v=1.exp&key=' + encodeURIComponent(key)
          script.onload = resolve
          script.onerror = error => {
            tencentMapLoading = null
            reject(error)
          }
          document.head.appendChild(script)
        })
      })

      return tencentMapLoading
    },
    drawMarkers(autoFit = true) {
      const stores = this.validStoreList
      if (!stores.length) {
        const center = new window.TMap.LatLng(23.12908, 113.26436)
        if (!this.map) {
          this.map = new window.TMap.Map(this.$refs.storeMap, {
            center,
            zoom: 12
          })
        } else {
          this.map.setCenter(center)
        }
        this.bindMapClick()
        if (this.markerLayer) this.markerLayer.setMap(null)
        if (this.labelLayer) this.labelLayer.setMap(null)
        return
      }
      const centerStore = stores[0]
      const center = new window.TMap.LatLng(centerStore.lat, centerStore.lng)
      if (!this.activeStoreKey) {
        this.activeStoreKey = this.getStoreKey(centerStore, 0)
      }

      if (!this.map) {
        this.map = new window.TMap.Map(this.$refs.storeMap, {
          center,
          zoom: stores.length > 1 ? 12 : 15
        })
      } else if (autoFit && stores.length === 1) {
        this.map.setCenter(center)
      }
      this.bindMapClick()

      if (this.markerLayer) {
        this.markerLayer.setMap(null)
      }
      if (this.labelLayer) {
        this.labelLayer.setMap(null)
      }

      this.markerLayer = new window.TMap.MultiMarker({
        map: this.map,
        styles: {
          marker: new window.TMap.MarkerStyle({
            width: 25,
            height: 35,
            anchor: {x: 12, y: 35}
          }),
          activeMarker: new window.TMap.MarkerStyle({
            width: 31,
            height: 43,
            anchor: {x: 15, y: 43}
          })
        },
        geometries: stores.map((item, index) => {
          const storeKey = this.getStoreKey(item, index)
          return {
            id: storeKey,
            styleId: this.activeStoreKey === storeKey ? 'activeMarker' : 'marker',
            position: new window.TMap.LatLng(item.lat, item.lng),
            properties: {
              title: this.getStoreName(item)
            }
          }
        })
      })

      this.labelLayer = new window.TMap.MultiLabel({
        id: 'store-name-label',
        map: this.map,
        styles: {
          label: new window.TMap.LabelStyle({
            color: '#303133',
            size: 13,
            offset: {x: 0, y: -46},
            alignment: 'center',
            verticalAlignment: 'middle'
          }),
          activeLabel: new window.TMap.LabelStyle({
            color: '#409EFF',
            size: 14,
            offset: {x: 0, y: -52},
            alignment: 'center',
            verticalAlignment: 'middle'
          })
        },
        geometries: stores.map((item, index) => {
          const storeKey = this.getStoreKey(item, index)
          return {
            id: 'label_' + storeKey,
            styleId: this.activeStoreKey === storeKey ? 'activeLabel' : 'label',
            position: new window.TMap.LatLng(item.lat, item.lng),
            content: this.getStoreName(item)
          }
        })
      })

      if (autoFit && stores.length > 1 && this.map.fitBounds) {
        const lats = stores.map(item => item.lat)
        const lngs = stores.map(item => item.lng)
        const sw = new window.TMap.LatLng(Math.min.apply(null, lats), Math.min.apply(null, lngs))
        const ne = new window.TMap.LatLng(Math.max.apply(null, lats), Math.max.apply(null, lngs))
        this.map.fitBounds(new window.TMap.LatLngBounds(sw, ne), 80)
      }
    },
    bindMapClick() {
      if (!this.map || this.mapClickHandler) return
      this.mapClickHandler = evt => {
        this.updateCurrentLocation(evt.latLng)
      }
      this.map.on('click', this.mapClickHandler)
    }
  }
};
</script>

<style scoped>
.store-apply-info {
  min-height: 620px;
}

.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.page-head h2 {
  color: #303133;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
}

.sub-title {
  color: #909399;
  line-height: 22px;
}

.head-actions {
  display: flex;
  gap: 8px;
}

.content-layout {
  display: grid;
  grid-template-columns: minmax(420px, 1fr) minmax(260px, 320px) minmax(420px, 1.1fr);
  gap: 20px;
  align-items: start;
}

.left-panel,
.middle-panel,
.right-panel {
  min-width: 0;
}

.middle-panel {
  padding-top: 36px;
}

.info-section {
  margin-bottom: 18px;
}

.section-title {
  color: #303133;
  font-size: 15px;
  font-weight: 600;
  line-height: 26px;
  margin-bottom: 10px;
}

.member-card {
  display: flex;
  align-items: center;
  min-height: 86px;
  padding: 16px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fff;
}

.member-meta {
  color: #606266;
  line-height: 24px;
  margin-left: 14px;
}

.member-name {
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}

.map-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.map-actions {
  display: flex;
  flex-shrink: 0;
  gap: 6px;
}

.location-edit-bar {
  margin-bottom: 8px;
  padding: 8px 10px;
  border: 1px solid #f5dab1;
  border-radius: 4px;
  background-color: #fdf6ec;
  color: #e6a23c;
  line-height: 18px;
}

.map-wrap {
  position: relative;
  overflow: hidden;
  height: 520px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #f5f7fa;
}

.store-map {
  width: 100%;
  height: 100%;
}

.map-empty {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #909399;
  font-size: 14px;
  white-space: nowrap;
}

.store-list-box {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}

.store-list-head {
  height: 36px;
  padding: 0 12px;
  border-bottom: 1px solid #ebeef5;
  background-color: #f5f7fa;
  color: #303133;
  font-weight: 600;
  line-height: 36px;
}

.store-list {
  max-height: 520px;
  overflow-y: auto;
}

.store-item {
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 8px 12px;
  border-bottom: 1px solid #ebeef5;
  color: #606266;
  cursor: pointer;
  outline: none;
  transition: background-color .2s ease, color .2s ease;
}

.store-item:last-child {
  border-bottom: none;
}

.store-item:hover,
.store-item:focus,
.store-item.active {
  background-color: #ecf5ff;
  color: #409EFF;
}

.store-item i {
  color: #409EFF;
  margin-right: 6px;
}

.store-text {
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.store-text span {
  display: flex;
  flex: 1;
  gap: 6px;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.store-text em {
  flex-shrink: 0;
  color: #909399;
  font-style: normal;
}

@media screen and (max-width: 1100px) {
  .content-layout {
    grid-template-columns: 1fr;
  }

  .middle-panel {
    padding-top: 0;
  }

  .map-wrap {
    height: 420px;
  }

  .store-list {
    max-height: 320px;
  }
}
</style>
